<template>
    <div class="singer-select">
        <div class="filter">
            <h5>Filter und Aktionen</h5>
            <b-row>
                <b-col cols="8">
                    <CheckboxSelect
                        :options="fastSelect.options"
                        :isBusy="fastSelect.busy"
                        size="sm"
                        :selectSize="8"
                        v-model="fastSelect.selected"
                    />
                    <small
                        class="text-secondary"
                    >Mit diesem Filter können alle Mitglieder nach ihrem Status diesem Werk zugeordnet oder abgewählt werden</small>
                </b-col>
                <b-col cols="4">
                    <b-dropdown
                        id="status-action"
                        text="Status anpassen"
                        variant="primary"
                        class="btn-block"
                    >
                        <b-dropdown-item @click="selectAll()">Alle auswählen</b-dropdown-item>
                        <b-dropdown-item @click="deselectAll()">Alle abwählen</b-dropdown-item>
                    </b-dropdown>
                    <b-button
                        id="reset"
                        variant="outline-danger"
                        @click="fetchMitglieder"
                        block
                    >Zurücksetzen</b-button>
                </b-col>
            </b-row>
        </div>
        <hr />
        <div class="selection">
            <h5>Mitgliederauswahl</h5>
            <Table
                :fields="mitglieder.fields"
                :items="mitglieder.items"
                size="sm"
                showFilter
                :isBusy="mitglieder.busy"
            >
                <template v-slot:check="{row: row}">
                    <input type="checkbox" false-value="0" true-value="1" v-model="row.item.check" />
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";
import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect";

const StatusApi = ApiFactory.get("status");
const WerkeApi = ApiFactory.get("werke");

import "./SingerSelect.scss";

export default {
    name: "SingerSelect",
    components: {
        Table,
        CheckboxSelect
    },
    props: ["id"],
    data() {
        return {
            fastSelect: {
                options: [],
                busy: false,
                selected: []
            },
            mitglieder: {
                busy: false,
                selected: null,
                fields: [
                    {
                        key: "check",
                        label: "",
                        class: "text-center"
                    },
                    {
                        key: "id",
                        label: "ID",
                        sortable: true
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true
                    },

                    {
                        key: "vorname",
                        label: "Vorname",
                        sortable: true
                    },
                    { key: "name", label: "Name", sortable: true }
                ],
                items: []
            }
        };
    },
    created() {
        this.fetchStatus();
        this.fetchMitglieder();
    },
    watch: {
        items: {
            handler(value) {
                this.$emit("update", value);
            },
            deep: true
        }
    },
    computed: {
        items() {
            return this.mitglieder.items;
        }
    },
    methods: {
        async fetchStatus() {
            this.fastSelect.busy = true;
            const response = await StatusApi.getSinger();
            if (response.ok) {
                var data = response.json.collection;
                data = data.map(item => {
                    return {
                        value: item.value,
                        text: item.value + " (" + item.name + ")"
                    };
                });
                this.fastSelect.options = data;
            }
            this.fastSelect.busy = false;
        },
        async fetchMitglieder() {
            this.mitglieder.busy = true;
            const response = await WerkeApi.getMitglieder(this.id);
            if (response.ok) {
                var data = response.json.collection;
                this.mitglieder.items = data;
            }
            this.mitglieder.busy = false;
        },
        selectAll() {
            this.multipleSelect(1);
            this.fastSelect.selected = [];
        },
        deselectAll() {
            this.multipleSelect(0);
            this.fastSelect.selected = [];
        },
        multipleSelect(value) {
            const selection = this.fastSelect.selected;
            if (selection.length > 0) {
                this.mitglieder.items = this.mitglieder.items.map(item => {
                    var valid = false;
                    selection.forEach(status => {
                        if (status == item.status) {
                            valid = true;
                        }
                    });
                    if (valid) {
                        item.check = value;
                    }
                    return item;
                });
            }
        }
    }
};
</script>